import React from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import createHistory from 'history/createBrowserHistory';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Home from '../components/Home';
import Game from '../components/Game';
import More from '../components/More';
import Info from '../components/Info';
import About from '../components/About';
import Contact from '../components/Contact';
import Search from '../components/Search';
import HamburgerMenuPage from '../components/HamburgerMenuPage';

export const history = createHistory();

const AppRouter = () => (
  <Router history={history}>
    <div>
      <Switch>
        <DefaultLayout path="/" component={Home} exact />
        <DefaultLayout path="/games" component={Game} />
        <DefaultLayout path="/more" component={More} />
        <DefaultLayout path="/about" component={About} />
        <DefaultLayout path="/contact" component={Contact} />
        <DefaultLayout path="/search" component={Search} />
        <DefaultLayout path="/menu" component={HamburgerMenuPage} />
        <DefaultLayout path="/info/:id" component={Info} />
        <DefaultLayout component={Home} />
      </Switch>
    </div>
  </Router>
);

const DefaultLayout = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={matchProps => (
      <div className="body_container">
        <Header />
        <Component {...matchProps} />
        <Footer />
      </div>
    )}
  />
);

// <PostLayout path="/posts/:post" component={PostComponent} />

// const PostLayout = ({ component: Component, ...rest }) => {
//   return (
//     <DefaultLayout
//       {...rest}
//       component={matchProps => (
//         <div className="Post">
//           <div className="Post-content">
//             <Component {...matchProps} />
//           </div>
//           <div className="Post-aside">
//             <SomeSideBar />
//           </div>
//         </div>
//       )}
//     />
//   );
// };

export default AppRouter;



// WEBPACK FOOTER //
// ./src/routers/AppRouter.js